import { Link } from "react-router-dom";
import type { Title } from "@/mocks/titles";

interface TitleCardProps {
  title: Title;
  size?: "default" | "compact";
}

export default function TitleCard({ title, size = "default" }: TitleCardProps) {
  const isCompact = size === "compact";
  return (
    <Link
      to={`/detail/${title.id}`}
      data-product-shop
      className="group block cursor-pointer"
      aria-label={`查看《${title.name}》详情`}
    >
      <div className={`relative w-full ${isCompact ? "aspect-[3/4]" : "aspect-[3/4]"} rounded-lg overflow-hidden bg-background-200`}>
        <img
          src={title.poster}
          alt={`《${title.name}》海报`}
          title={`${title.name} 星光传媒影视作品`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/10 to-transparent opacity-90"></div>
        <div className="absolute top-2.5 left-2.5 flex items-center gap-1.5">
          <span className="px-2 py-0.5 rounded text-[11px] font-medium bg-background-50/90 text-primary-900 backdrop-blur-sm">
            {title.type === "movie" ? "电影" : "剧集"}
          </span>
          {title.year >= 2026 && (
            <span className="px-2 py-0.5 rounded text-[11px] font-medium bg-accent-500 text-primary-950">新上线</span>
          )}
        </div>
        <div className="absolute top-2.5 right-2.5 flex items-center gap-1 px-2 py-0.5 rounded bg-primary-950/70 backdrop-blur-sm">
          <i className="ri-star-fill text-accent-400 text-[11px] w-3 h-3 flex items-center justify-center"></i>
          <span className="text-[11px] font-medium text-background-50">{title.rating.toFixed(1)}</span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <p className="text-[11px] text-background-200/80 mb-1 truncate">
            {title.genres.join(" · ")} · {title.year}
          </p>
          <h3 className="font-heading text-base font-medium text-background-50 truncate">{title.name}</h3>
        </div>
        <div className="absolute inset-x-0 bottom-0 translate-y-full group-hover:translate-y-0 transition-transform duration-300 bg-background-50 px-3 py-2.5">
          <p className="text-[11px] md:text-xs text-foreground-600 line-clamp-2 leading-relaxed">{title.tagline}</p>
        </div>
      </div>
      {!isCompact && (
        <div className="mt-2.5">
          <p className="text-xs text-foreground-500 truncate">
            {title.region} · {title.duration}
          </p>
        </div>
      )}
    </Link>
  );
}